<template>
  <div class="logo-on login">
    <!--        <img class="logo" src="../../../../public/img/signup/logo.png">-->
    <van-cell-group class="logo-cell-type">
      <van-field
          v-model="accNumber"
          required
          clearable
          label="账号"
          placeholder="请输入手机号"
      />
      <van-field :type="passwordType" label="密码" v-model="password" placeholder="请输入密码"
                 maxlength="18"
                 clearable :required="true" @click-right-icon="passwordDisplay" class="pass-van">
        <img slot="right-icon" src="~@public/img/user/login/eye.png" v-if="isOpen"/>
        <img slot="right-icon" src="~@public/img/user/login/eye-o.png" v-if="isClose"/>
      </van-field>
      <!--验证码-->
<!--      <pic-code ref="verificationCode" @setVerificationStatus="getVerificationStatus"></pic-code>-->
      <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                  :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>

    </van-cell-group>
    <button class="nextbtn" @click="submit">登录</button>

    <p class="lert">
      <router-link tag="a" to="/sign-up/forget-password">找回密码</router-link>
      <!--            <router-link tag="a" to="/sign-up/account-appeal/black">二次核验</router-link>-->
<!--      <router-link tag="a" to="/sign-up/account-appeal">账号申诉</router-link>-->
    </p>
    <div class="tips">
      <div class="tips-img tips-img-tel">
        <p>本服务由湖北省统一身份认证平台提供</p>
        <p>咨询服务热线:<span class="font36">12345</span></p>

      </div>
      <div class="tips-img tips-img-danger">
        <p>账号(手机号)变更或注册账号提示已注册，需下载<span style="color:#e9360a;font-weight:bold">鄂汇办APP</span>进行账号申诉</p>
        <p>已在湖北政务服务网或鄂汇办APP注册的用户请直接登陆</p>
      </div>
    </div>
    <div class="tips-type" v-show="tips">
      未查询到匹配的实名信息
    </div>
    <!--注册的提示框-->
    <van-dialog class="zhuced"
                v-model="showPops"
                @cancel="confirmFalse"
                @confirm="cancelRegister"
                show-confirm-button confirm-button-text="注册"
                show-cancel-button cancel-button-text="取消"
    >
      <div class="contentbox">
        <p>该账号尚未被注册</p>
        <p>请点击“注册按钮”进行注册</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { CellGroup, Field, Toast, Dialog } from 'vant'
import PicCode from '@/components/verification-code-input/PicCode' // 短信验证码组件
import { checkPhoneNum, checkPeopleId } from '@assets/js/api/Regular'
import { memberApi } from '@/api/member'
import { setToken, removeToken } from "@/utils/auth"
import Vue2Verify from "@/views/signUp/verify/verify";
export default {
  name: "LoginV2",
  components: {
    Vue2Verify,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    PicCode
  },
  data() {
    return {
      show:false,
      form: {
        phone: '',
        password: '',
        code: '',
        verCode:'',
        verCodeKey:'',
        captchaVerification:''
      },
      value: '',
      showPops: false,
      tips: false,
      accNumber: this.$route.query.phone,
      isOpen: true, //设置密码闭眼显示与隐藏
      isClose: false, //设置密码睁眼显示与隐藏
      password: '',
      typeId: 1,
      passwordType: 'password',
      //存放图形验证码
      verificationInfo: {},
      returnUrl: "",
    }
  },
  created() {

  },
  mounted() {
    Toast.setDefaultOptions({ duration: 1500 });
    this.returnUrl = this.$route.query.returnUrl;
    // 将登录状态设置为未登录
    this.$store.commit('LOGIN_SWITCH', false)
    // 删除用户信息,不移除用户信息，首页的我的证件信息会显示，这样就造成数据不正常。
    this.$cookie.removeUser()
    removeToken('access_token')
    this.logger.visit('901','0')
  },

  methods: {

    submit(){
      if (this.accNumber == "") {
        Toast.fail('请输入账号');
        return
      } else if (!checkPhoneNum(this.accNumber) && !checkPeopleId(this.accNumber)) {
        Toast.fail('请输入正确的手机号码');
        return
      } else if (!this.password) {
        Toast('请输入密码')
        return
      }else {
        this.show = true
      }
    },
    async success(val) {
      this.show = false;
      Toast.loading({
        duration: 0,       // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '登录中...'
      })
      try {
        let data = {
          acountId: this.accNumber,
          password: this.password,
          verificationCode: val.captchaVerification,
          source: this.$device(),
          wxOpenId: this.$cookie.getOpenId()
        }
        let res = await this.$httpUtils.postGatewayUtils(memberApi.memberNewLogin, data)
        console.log(res);
        if (res.data.access_token) {
          const access_token = res.data.access_token
          const refresh_token = res.data.refresh_token
          setToken('access_token', access_token)
          setToken('refresh_token', refresh_token)
          const info = await this.$httpUtils.getGatewayUtils(memberApi.getUserInfo)
          const userInfo = info.data.data
          this.$cookie.setUser(userInfo)
          this.$store.commit('LOGIN_SWITCH', true)
          this.logger.visit('901','1')
          Toast.success('登录成功')
          if (this.returnUrl) {
            this.$router.push(decodeURIComponent(this.returnUrl));
          } else {
            this.$router.push("/userCenter");
          }
        } else if (res.data.status === 211014) {
          this.showPops = true
          // this.$refs.verify.show();
        } else {
          if(res.data.msg=='请进行二次核验'){
            this.$router.push("/sign-up/account-appeal/black");
          }else if (res.data.msg) {
            Toast.fail(res.data.msg)
          } else {
            Toast.fail('登陆异常，请稍后重试')
          }
          // this.$refs.verify.show();
        }
      } catch (e) {
        // this.$refs.verify.show();
        Toast.fail('服务器运行失败，请稍后再试。')
        console.log(error)
      }

    },
    async nextTips() {
      this.$refs.verificationCode.passValue();
      if (this.accNumber == "") {
        Toast.fail('请输入账号');
        return
      } else if (!checkPhoneNum(this.accNumber) && !checkPeopleId(this.accNumber)) {
        Toast.fail('请输入正确的手机号码或身份证号码');
        return
      } else if (!this.password) {
        Toast('请输入密码')
      } else if (this.verificationInfo.verificationCode === undefined) {
        Toast.fail("请输入图形验证码")
        return
      } else if (!this.verificationInfo.IsInputSuccStatus) {
        Toast.fail("请输入正确的图形验证码")
        return
      } else {
        Toast.loading({
          duration: 0,       // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '登录中...'
        })
        try {
          let data = {
            acountId: this.accNumber,
            password: this.password,
            vercodeGuid: this.verificationInfo.verificationCodeGuid,
            verificationCode: this.verificationInfo.verificationCode,
            source: this.$device(),
            wxOpenId: this.$cookie.getOpenId()
          }
          const res = await this.$httpUtils.postGatewayUtils(memberApi.memberLogin, data)
          console.log(res);
          if (res.data.access_token) {
            const access_token = res.data.access_token
            const refresh_token = res.data.refresh_token
            setToken('access_token', access_token)
            setToken('refresh_token', refresh_token)
            const info = await this.$httpUtils.getGatewayUtils(memberApi.getUserInfo)
            const userInfo = info.data.data
            this.$cookie.setUser(userInfo)
            this.$store.commit('LOGIN_SWITCH', true)
            this.logger.visit('901','1')
            Toast.success('登录成功')
            if (this.returnUrl) {
              this.$router.push(decodeURIComponent(this.returnUrl));
            } else {
              this.$router.push("/userCenter");
            }
          } else if (res.data.status === 211014) {
            this.showPops = true
            this.$refs.verificationCode.passValue();
            this.$refs.verificationCode.interactionVerificationCode()
          } else {
            if(res.data.msg=='请进行二次核验'){
              this.$router.push("/sign-up/account-appeal/black");
            }else if (res.data.msg) {
              Toast.fail(res.data.msg)
            } else {
              Toast.fail('登陆异常，请稍后重试')
            }
            this.$refs.verificationCode.passValue();
            this.$refs.verificationCode.interactionVerificationCode()
          }
        } catch (e) {
          this.$refs.verificationCode.passValue();
          this.$refs.verificationCode.interactionVerificationCode()
          Toast.fail('服务器运行失败，请稍后再试。')
          console.log(error)
        }

      }
    },
    /**
     * 控制确认密码的显示与隐藏
     */
    passwordDisplay() {
      if (this.passwordType === 'password') {
        this.isClose = true;
        this.isOpen = false;
        this.passwordType = 'text'
      } else {
        this.isClose = false;
        this.isOpen = true;
        this.passwordType = 'password'
      }
    },
    //获取图形验证码
    getVerificationStatus(value) {
      this.verificationInfo = value
    },
    /**
     * 去注册
     */
    cancelRegister() {
      this.showPops = false
      this.$router.push("/sign-up/register")
    },
    /**
     * 取消
     */
    confirmFalse() {
      this.showPops = false
    }
  }
}
</script>

<style scoped>
@import "~@assets/css/public/signup.css";

.login {
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.logo {
  margin-top: 98px;
  display: inline-block;
}

.tips {
  margin: 70px 0 10px 0
}

.login .nextbtn {
  margin-top: 10px;
}

.zhuced {
  font-size: 30px;
  color: #000;
}

.bluetext {
  color: #2664AD;
  font-weight: 700;
  font-size: 32px;
  padding-top: 5px
}

.contentbox {
  width: 100%;
  padding: 50px 0 30px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center
}

.contentbox p {
  width: 100%;
  text-align: center;
}
</style>
<style>
.logo-on .logo-cell-type {
  height: fit-content;
  width: 100%;
}
</style>
